<template>
    <!-- :close-on-outside-click="true" -->
    <!-- @hidden="onHidden" -->
    <DxPopup
        :drag-enabled="false"
        v-model:visible="show"
        content-template="popup-content"
        titleTemplate="popup-title" 
    >
        <template #popup-title>
            <div class="popup-title">
                <h4><slot name="popup-title"></slot></h4> 
            </div>
        </template>
        <template #popup-content>
            <div class="popup-content">
                <DxScrollView
                    width="100%"
                    height="100%"
                >
                    <slot name="popup-content"></slot>
                </DxScrollView>
            </div>
        </template>
    </DxPopup>
</template>

<script>
    /**
     * Importaciones devExtreme
     */
    import { DxPopup } from 'devextreme-vue/popup';
    import { DxScrollView } from 'devextreme-vue/scroll-view';

    /**
     * Importaciones Vue
     */

    /**
     * Importaciones Componentes
     */

    export default {
        name:'Popup',
        props:{
            show:{
                type: Boolean,
                default: false
            }
        },
        components:{
            DxPopup,
            DxScrollView,
        },
        // setup(props,context) {        

        //     const onHidden = (e) => {
        //         context.emit('hiddenPopup')
        //     }
            
        //     return {onHidden}
        // }
    }
</script>

<style>
    .popup-title {
        padding: 24px;
        display: flex;
        justify-content: center;
    }
    .popup-content {
        padding: 24px;
    }
    .popup-title h4 {
        text-transform: uppercase;
        padding: 8px 0;
    }
</style>